module.exports = __webpack_public_path__ + "static/proudlycaringforveterans-vertbadge-225x300-8577a9a8a925e84a41fe033d6f78a765.png";